import React from 'react';
import { millisecondToDuration } from '../../../common/utils';
var TimeCell = function (_a) {
    var value = _a.value;
    return React.createElement("span", null, value ? millisecondToDuration(value) : '');
};
export default TimeCell;
//# sourceMappingURL=TimeCell.js.map